const fr = {
    common: {
        cancel: 'Annuler',
        close: 'Fermer',
        goBack: 'Retour',
        settings: 'Paramètres',
        signOut: 'Se déconnecter',
        ok: 'OK',
        loading: 'Chargement…',
        tryAgain: 'Réessayer',
        offline: 'Hors ligne'
    },
    loading: {
        ariaLabel: 'Chargement'
    },
    login: {
        title: 'Connexion à 7punches',
        subtitle: 'Veuillez utiliser votre compte 7shifts',
        signIn: 'Se connecter',
        redirecting: 'Redirection…',
        errorFallback: 'Impossible de démarrer la connexion'
    },
    callback: {
        failed: 'Échec de la connexion',
        tryAgain: 'Réessayer'
    },
    selection: {
        title: 'Sélectionnez votre emplacement',
        companyLabel: 'Entreprise',
        companyPlaceholder: 'Sélectionnez une entreprise',
        locationLabel: 'Emplacement',
        locationPlaceholder: 'Sélectionnez un emplacement',
        next: 'Suivant'
    },
    footer: {
        poweredBy: 'Propulsé par 7shifts'
    },
    pinGrid: {
        title: 'Entrez votre code de pointage',
        clear: 'EFFACER',
        backspace: 'Retour arrière',
        punch: 'Pointer',
        srNoDigits: 'Aucun chiffre saisi',
        srDigitCountSingular: '1 chiffre saisi',
        srDigitCountPlural: '{count} chiffres saisis'
    },
    tips: {
        title: 'Saisir les pourboires',
        subtitle: 'Combien avez-vous gagné en pourboires ce quart ?',
        amountLabel: 'Montant du pourboire',
        validationError: 'Veuillez saisir un montant de pourboire valide.',
        submit: 'Soumettre',
        confirm: 'Confirmer',
        skip: 'Passer',
        keypadAriaLabel: 'Pavé numérique de montant de pourboire'
    },
    department: {
        title: 'Sélectionnez un département'
    },
    role: {
        selectTitle: 'Sélectionnez un rôle',
        confirmTitle: 'Confirmez votre rôle'
    },
    attestation: {
        confirm: 'Confirmer'
    },
    healthCheck: {
        unavailableTitle: 'Vérification santé non disponible',
        unavailableBody:
            'Impossible de charger les questions de vérification santé. Veuillez réessayer ou annuler.',
        dismiss: 'Ignorer',
        submitFallback: 'Soumettre'
    },
    punchResult: {
        clockIn: {
            heading: 'Pointage effectué !',
            subtitle: 'Bienvenue, {name} !'
        },
        clockOut: {
            heading: 'Sortie pointée !',
            subtitle: 'À bientôt, {name} !'
        },
        breakStart: {
            heading: 'Pause commencée',
            subtitle: 'Profitez de votre pause, {name} !'
        },
        breakEnd: {
            heading: 'Bon retour !',
            subtitle: 'Au boulot, {name} !'
        },
        ok: 'OK ({countdown})'
    },
    offlinePunchRecorded: {
        title: 'Pointage hors ligne enregistré',
        subtitle:
            'Nous synchroniserons automatiquement ce pointage dès que vous serez de nouveau en ligne.',
        ok: 'OK ({countdown})'
    },
    error: {
        defaultHeader: "Une erreur s'est produite",
        invalidPunchId: {
            header: 'Code de pointage incorrect',
            body: 'Veuillez réessayer.'
        },
        breakTooShort: {
            header: 'Retour trop tôt',
            body: "Votre pause n'a pas atteint la durée minimale."
        },
        healthCheckFailed: {
            header: 'Impossible de pointer en raison du contrôle santé',
            body: 'En fonction de vos réponses, vous ne pouvez pas terminer votre quart. Veuillez contacter votre responsable.'
        },
        notAssignedToLocation: {
            header: "Vous n'êtes pas assigné(e) à cet emplacement",
            body: 'Veuillez contacter votre responsable pour être affecté(e) à cet emplacement avant de pointer.'
        },
        clockInTooEarly: {
            header: 'Trop tôt pour pointer',
            body: "Vous ne pouvez pas encore pointer. Veuillez réessayer plus près de l'heure de début de votre quart."
        },
        shiftNotScheduled: {
            header: "Vous n'êtes pas prévu(e) au travail",
            body: "Il semble que vous n'ayez pas de quart prévu aujourd'hui. Veuillez contacter votre responsable."
        },
        network: {
            header: 'Pas de connexion',
            body: 'Impossible de se connecter à 7shifts.com. Veuillez vérifier votre connexion internet et réessayer.'
        },
        serverOrUnknown: {
            header: "Une erreur s'est produite",
            body: 'Une erreur inconnue est survenue. Veuillez réessayer.'
        }
    },
    userStatus: {
        greeting: 'Bonjour, {firstName} !',
        haveAGreatShift: 'Bonne journée de travail.',
        yourShifts: 'Vos quarts',
        currentShift: 'Quart actuel',
        punchedIn: 'Pointé',
        onBreak: 'En pause',
        timeOnShift: 'temps de travail',
        onBreakElapsed: '{elapsed} en pause',
        breakEndsAt: 'se termine à {time}',
        noScheduledShifts: 'Aucun quart prévu',
        noShiftsToday: "Vous n'avez pas de quarts aujourd'hui."
    },
    account: {
        noCompanies: 'Aucune entreprise trouvée pour ce compte.',
        failedToLoadCompanies: 'Échec du chargement des entreprises.',
        noLocations: 'Aucun emplacement trouvé pour cette entreprise.',
        failedToLoadLocations: 'Échec du chargement des emplacements.',
        failedToLoadAccount: 'Échec du chargement du compte.'
    },
    settings: {
        changeLocation: "Changer d'emplacement",
        logout: 'Se déconnecter',
        theme: 'Thème',
        themeLight: 'Clair',
        themeDark: 'Sombre',
        themeUrlLocked:
            'Le thème a été initialement défini par le paramètre URL.',
        verifyLogoutTitle: 'Confirmer la déconnexion',
        verifyLogoutSubmit: 'Se déconnecter',
        verifyChangeLocationTitle: "Confirmer le changement d'emplacement",
        verifyChangeLocationSubmit: "Changer d'emplacement",
        verifyError: 'Punch ID incorrect. Veuillez réessayer.'
    },
    inactivity: {
        title: 'Toujours là ?',
        subtitle: "Vous n'avez pas touché l'écran depuis un moment.",
        stayActive: 'Je suis toujours là !',
        signOut: 'Se déconnecter',
        signOutCountdown: 'Se déconnecter ({countdown})'
    },
    sessionExpired: {
        title: 'Session expirée',
        message:
            "Vous avez été déconnecté en raison d'inactivité. Veuillez vous reconnecter.",
        messageWebview:
            "Vous avez été déconnecté en raison d'inactivité. Veuillez utiliser l'application pour vous reconnecter."
    },
    externalUser: {
        signingIn: 'Connexion en cours…',
        done: 'Vous êtes prêt !'
    },
    offline: {
        banner: {
            heading: 'Aucune connexion Internet',
            body: "Vous pouvez toujours pointer votre arrivée et votre départ, mais les autres fonctionnalités sont limitées jusqu'à votre reconnexion.",
            timeLimitPrefix: 'Vous pouvez pointer hors ligne pendant ',
            daysSingular: 'encore 1 jour',
            daysPlural: 'encore {count} jours',
            timeLimitSuffix:
                '. Veuillez vous reconnecter bientôt pour continuer à utiliser la pointeuse.'
        },
        lockout: {
            heading: 'Limite hors ligne atteinte',
            body: "Vous ne pouvez pas pointer tant que cet appareil n'est pas reconnecté à Internet."
        },
        intermediate: {
            greeting: 'Bonjour !',
            haveAGreatShift: 'Passez un excellent quart de travail.',
            heading: 'Vous êtes hors ligne',
            body: "Vous pouvez toujours pointer votre arrivée et votre départ. Nous synchroniserons vos pointages dès que vous serez de nouveau en ligne.",
            punchButton: 'Pointer hors ligne'
        }
    }
} as const;

export default fr;
